import { LabelColor } from '../../models';

export const GMAIL_LABEL_COLORS: LabelColor[] = [
  { backgroundColor: '#f6c5be', textColor: '#000000' },
  { backgroundColor: '#fef1d1', textColor: '#000000' },
  { backgroundColor: '#ffe6c7', textColor: '#000000' },
  { backgroundColor: '#fce8b3', textColor: '#000000' },
  { backgroundColor: '#b9e4d0', textColor: '#000000' },
  { backgroundColor: '#c6f3de', textColor: '#000000' },
  { backgroundColor: '#89d3b2', textColor: '#000000' },
  { backgroundColor: '#a0eac9', textColor: '#000000' },
  { backgroundColor: '#c9daf8', textColor: '#000000' },
  { backgroundColor: '#a4c2f4', textColor: '#000000' },
  { backgroundColor: '#e4d7f5', textColor: '#000000' },
  { backgroundColor: '#d0bcf1', textColor: '#000000' },
  { backgroundColor: '#fcdee8', textColor: '#000000' },
  { backgroundColor: '#fbc8d4', textColor: '#000000' },
  { backgroundColor: '#efa093', textColor: '#000000' },
  { backgroundColor: '#ffd6a2', textColor: '#000000' },
];
